export function requestAnimationFrame(callback: VoidFunction): void {
  window.requestAnimationFrame(callback);
}
